import { render, staticRenderFns } from "./DirectorEdges.vue?vue&type=template&id=66524c0e&"
import script from "./DirectorEdges.vue?vue&type=script&lang=js&"
export * from "./DirectorEdges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports